/**
 * XION Medical product data — Compact cameras (Veezar)
 * Content sourced from xion-medical.com (split from completeProductsData.js).
 */

export const compactCameras = {
  id: 'compact-cameras',
  name: 'Compact Cameras',
  slug: 'compact-cameras',
  category: 'Compact Cameras',
  description: 'The Veezar compact cameras from XION combine camera electronics, optics and endoscope coupler in a single handy device. Because no separate control unit is required, they are particularly suitable where space is limited or for office applications.',
  overview: 'Full HD resolution, freely programmable function keys, a fixed focal length of 22 mm and an extra-long kink protector. Waterproof and fully immersible in disinfectant solution as well as wipe-disinfectable, the compact cameras combine with endoscopes and other application parts equipped with a DIN eyecup.',
  products: [
    {
      id: 'veezar-compact-camera-cf20',
      name: 'Veezar Compact Camera CF20',
      slug: 'veezar-compact-camera-cf20',
      tagline: 'Stroboscopy-ready Full HD compact camera',
      description: 'The Veezar Compact Camera CF20 combines camera electronics, optics and endoscope coupler in a single handy device. It can be used for stroboscopic applications in combination with the Veezar Illumination Head IH10 (with microphone) and the EndoCOMPACT Veezar Control Panel.',
      features: [
        'Full HD resolution',
        'Stroboscopy-ready (with Veezar IH10 + EndoCOMPACT Veezar Control Panel)',
        'Combines with endoscopes / application parts with a DIN eyecup',
        'Machine-cleanable in a cleaning and disinfecting device (CDD)',
        'Waterproof, fully immersible and wipe-disinfectable',
        'Freely programmable function keys',
        'Fixed focal length 22 mm with extra-long kink protector'
      ],
      specifications: {
        resolution: 'Full HD',
        focalLength: '22 mm (fixed)',
        application: 'Stroboscopy / general endoscopy'
      },
      images: ['/products/transparent/veezar-kompaktkamera-web.png']
    },
    {
      id: 'veezar-compact-camera-cf10',
      name: 'Veezar Compact Camera CF10',
      slug: 'veezar-compact-camera-cf10',
      tagline: 'Compact Full HD camera for the EndoOFFICE Veezar system',
      description: 'The Veezar Compact Camera CF10 integrates camera electronics, optics and endoscope coupler in a single handy device. It is designed for the EndoOFFICE Veezar system and is ideal where space is limited or for office applications.',
      features: [
        'Full HD resolution',
        'Designed for the EndoOFFICE Veezar system',
        'Combines with endoscopes / application parts with a DIN eyecup',
        'Machine-cleanable in a cleaning and disinfecting device (CDD)',
        'Waterproof, fully immersible and wipe-disinfectable',
        'Freely programmable function keys',
        'Fixed focal length 22 mm with extra-long kink protector'
      ],
      specifications: {
        resolution: 'Full HD',
        focalLength: '22 mm (fixed)',
        application: 'Office endoscopy (EndoOFFICE Veezar)'
      },
      images: ['/products/transparent/veezar-kompaktkamera-web.png']
    },
    {
      id: 'veezar-video-otoscope',
      name: 'Veezar Video Otoscope',
      slug: 'veezar-video-otoscope',
      tagline: 'Brilliant imaging for otoscopic applications',
      description: 'The Veezar Video Otoscope is ideal for otoscopic applications. An integrated LED light source and a high-resolution image sensor ensure brilliant imaging, while an integrated preheating system effectively prevents the lens from fogging.',
      features: [
        'Integrated LED light source and high-resolution image sensor',
        'Integrated preheating system prevents lens fogging',
        'Preheatable ear specula for fog-free working',
        'Freely programmable function keys',
        'Waterproof and fully immersible in disinfectant solution',
        'Wipe-disinfectable with extra-long kink protector'
      ],
      specifications: {
        type: 'Video otoscope',
        illumination: 'Integrated LED',
        feature: 'Anti-fog preheating system'
      },
      images: ['/products/transparent/veezar-video-otoskop-web.png']
    }
  ]
};
